import { CompareCredit } from '../../types'
import cn from 'utils/classnames'
import { useShouldIncreaseProductVisibilityExp384 } from 'utils/experimentation/useShouldIncreaseProductVisibility'

export const TopContainer: React.FC<
  React.PropsWithChildren<{ view: CompareCredit.CardPanelProps['view'] }>
> = ({ children, view }) => {
  // 2025.06: EXP-384 Slim Category Design
  const shouldIncreaseProductVisibility =
    useShouldIncreaseProductVisibilityExp384()

  return (
    <div
      className={cn({
        'md:w-3/4 lg:w-4/5 / lg:pl-8':
          view === 'list' && shouldIncreaseProductVisibility,
        'md:w-72pct lg:w-9/12 / lg:pl-10':
          view === 'list' && !shouldIncreaseProductVisibility,
      })}
    >
      {children}
    </div>
  )
}
